import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/groups/page';

export const Route = createFileRoute('/_app/settings/groups/')({
  component: Page,
});
